/**
 * Обход проблемы: если элемент видимый, размер для него берётся из стилей и получается целочисленный
 * через getComputedStyle получается более точный размер
 */
"use strict";
$.fn.computedSize = function(){
    if (!this.length || !this[0]){
        return null;
    }
    var elem = this[0],
        $elem = $(elem),
        style = (elem.ownerDocument.defaultView.opener ? elem.ownerDocument.defaultView : window).getComputedStyle(elem, null);

    // Если контейнер имеет размер в %, и при этом находится в невидимом блоке (список страниц на неактивной вкладке)
    // то стиль будет возвращать размеры в %, нужно вычислить, умножив % на размеры родителя

    if (style.width.indexOf("%") > -1 && !$elem.hasClass("top-level") && $elem.hasClass("page-container")) {
        var parent = $elem.parents(".page-container").computedSize();
        return {
            "width": parent.width * parseFloat(style.width) / 100,
            "height": parent.height * parseFloat(style.height) / 100,
        };
    } else {
        return {
            "width": parseFloat(style.width),
            "height": parseFloat(style.height),
        };
    }
};